import { Employee } from '../employee/employee.model';

export class WorkersCompensationAssignedEmployee extends Employee {
    protected static _resource =
        'payroll/companies/:company/workersCompensations/:workersCompensation/assignedEmployees';
}
